import { ConfigGlobalType } from "@shared/lib/types";

export const insightsiqPlatformWorkIdMap: { [key: string]: string } = {
  instagram: "9bb8913b-ddd9-430b-a66a-d74d846e6c66",
  youtube: "14d9ddf5-51c6-415e-bde6-f8ed36ad7054",
  // tiktok: "de55aeec-0dc8-4119-bf90-16b3d1f0c987",
  // twitter: "7645460a-96e0-4192-a3ce-a1fc30641f72",
  // twitch: "e4de6c01-5b78-4fc0-a651-24f44134457b",
  // facebook: "ad2fec62-2987-40a0-89fb-23485972598c",
  // substack: "fbf76083-710b-439a-8b8c-956f607ef2c1",
  // instagramLite: "fb7cafcf-60ed-468a-ad6d-6bb6899d0871",
  // adSense: "3e6f4cdd-2119-4125-aa0d-86eee4e20fcc",
  // spotify: "1db0b86c-a547-4119-9834-da927171a685",
  // linkedIn: "36410629-f907-43ba-aa0d-434ca9c0501a",
  // beehiiv: "24fcaa09-0a79-4deb-b074-d8efd900265b",
};

export const dynamicColumnsToShow = new Set([
  "creator_gender",
  "audience_locations",
  "audience_age",
  "audience_gender",
  "average_likes",
]);

export type SortOption = {
  label: string;
  value: { field: string; order: "DESCENDING" | "ASCENDING" };
};

export const SORT_OPTIONS: SortOption[] = [
  {
    label: "Followers",
    value: { field: "FOLLOWER_COUNT", order: "DESCENDING" },
  },
  {
    label: "Topic Relevance",
    value: { field: "TOPIC_RELEVANCE", order: "DESCENDING" },
  },

  {
    label: "Engagement Rate",
    value: { field: "ENGAGEMENT_RATE", order: "DESCENDING" },
  },
  {
    label: "Avg Views",
    value: { field: "AVERAGE_VIEWS", order: "DESCENDING" },
  },
  {
    label: "Reels Views",
    value: { field: "REELS_VIEWS", order: "DESCENDING" },
  },
];

export const IgGlobalFilters: ConfigGlobalType = [
  {
    facetName: "follower_count",
    title: "Followers",
    compType: "range",
    desc: "Filter creators by follower count",
    fType: "creator",
    hideFilter: true,
    optionsList: [
      { label: "Nano (1k - 10k)", value: { min: 1000, max: 10000 } },
      { label: "Micro (10k - 50k)", value: { min: 10000, max: 50000 } },
      { label: "Mid-Tier (50k - 100k)", value: { min: 50000, max: 100000 } },
      { label: "Macro (100k - 500k)", value: { min: 100000, max: 500000 } },
      { label: "Mega (500k - 1M)", value: { min: 500000, max: 1000000 } },
      { label: "Celebrity (1M+)", value: { min: 1000000 } },
    ],
  },

  {
    facetName: "creator_locations",
    title: "Location",
    compType: "multiList",
    desc: "Filter creators who is from the selected location. ",
    placeHolder: "Search country or city",
    fType: "creator",
    hideFilter: true,
  },

  {
    facetName: "topics",
    title: "Topics",
    compType: "multiList",
    desc: "Filter creators by topics",
    placeHolder: "Search by topics",
    fType: "creator",
    hideFilter: true,
  },
  {
    facetName: "creator_gender",
    title: "Creator's Gender",
    compType: "list",
    desc: "Filter creators by gender of the creator.",
    placeHolder: "",
    fType: "creator",
  },
  {
    facetName: "creator_age",
    title: "Creator's Age",
    compType: "range",
    desc: "Filter creators by creator's age.",
    placeHolder: "Select range",
    fType: "creator",
    optionsList: [
      { label: "13-17", value: { min: 13, max: 17 } },
      { label: "18-24", value: { min: 18, max: 24 } },
      { label: "25-34", value: { min: 25, max: 34 } },
      { label: "35-44", value: { min: 35, max: 44 } },
      { label: "45-54", value: { min: 45, max: 54 } },
      { label: "55-64", value: { min: 55, max: 64 } },
    ],
  },
  {
    facetName: "creator_language",
    title: "Creator's language",
    compType: "list",
    desc: "Filter creators by creators language.",
    placeHolder: "Search Language",
    fType: "creator",
  },
  {
    facetName: "is_verified",
    title: "Is verified?",
    compType: "checkbox",
    desc: "Filter creators by platform verification status.",
    placeHolder: "",
    fType: "creator",
  },
  {
    facetName: "bio_phrase",
    title: "Bio phrase",
    compType: "tags",
    desc: "Filter creators by the phrase they use in their bio.",
    fType: "creator",
    placeHolder: "Search keywords in the bio of Creators",
  },
  {
    facetName: "description_keywords",
    title: "Keywords",
    compType: "tags",
    desc: "Filter creators by keywords that can be found in creator's posts caption.",
    fType: "content",
    placeHolder: "Search by keywords",
  },
  {
    facetName: "hashtags",
    title: "Hashtags",
    compType: "tags",
    desc: "Shows creators who have mentioned the added hashtags in their posts. ",
    placeHolder: "Search By Hashtags",
    fType: "creator",
  },

  {
    facetName: "mentions",
    title: "Mentions",
    compType: "tags",
    desc: "Shows creators who have mentioned the added usernames in their posts. ",
    placeHolder: "Search by Mentions",
    fType: "creator",
  },
  {
    facetName: "instagram_options_reel_views",
    title: "Reel Views",
    compType: "range",
    desc: "Filter creators by  average reels views.",
    placeHolder: "Select range",
    fType: "performance",
    optionsList: [
      { label: "0 - 1k", value: { min: 0, max: 1000 } },
      { label: "1k - 10k", value: { min: 1000, max: 10000 } },
      { label: "10k - 50k", value: { min: 10000, max: 50000 } },
      { label: "50k - 100k", value: { min: 50000, max: 100000 } },
      { label: "100k - 500k", value: { min: 100000, max: 500000 } },
      { label: "500k - 1M", value: { min: 500000, max: 1000000 } },
      { label: "1M+", value: { min: 1000000 } },
    ],
  },
  {
    facetName: "engagement_rate",
    title: "Engagement Rate",
    compType: "inputNumber",
    desc: "Filter creators by engagement rates.",
    placeHolder: "Select engagement rate",
    fType: "performance",
    optionsList: [
      { label: ">2%", value: 2 },
      { label: ">4%", value: 4 },
      { label: ">6%", value: 6 },
      { label: ">8%", value: 8 },
      { label: ">10%", value: 10 },
    ],
  },
  {
    facetName: "audience_locations",
    title: "Top Audience Location",
    compType: "selectRange",
    desc: "Filter creators who's audience is from the selected location.",
    placeHolder: "Search country or city",
    fType: "audience",
  },

  {
    facetName: "audience_age",
    title: "Audience Age",
    compType: "selectRange",
    desc: "Filter creators by audience age.",
    placeHolder: "Search country or city",
    fType: "audience",
    optionsList: [
      { label: "13-17", value: { min: 13, max: 17 } },
      { label: "18-24", value: { min: 18, max: 24 } },
      { label: "25-34", value: { min: 25, max: 34 } },
      { label: "35-44", value: { min: 35, max: 44 } },
      { label: "45-54", value: { min: 45, max: 54 } },
      { label: "55-64", value: { min: 55, max: 64 } },
    ],
  },
  {
    facetName: "audience_gender",
    title: "Audience Gender",
    compType: "selectRange",
    desc: "Filter creators by gender of the audience.",

    placeHolder: "Search Gender",
    fType: "audience",
  },
];

export const YtGlobalFilters: ConfigGlobalType = [
  {
    facetName: "subscriber_count",
    hideFilter: true,
    title: "Subscribers",
    compType: "range",
    desc: "Filter creators by follower count",
    placeHolder: "",
    fType: "creator",
    optionsList: [
      { label: "Nano (1k - 10k)", value: { min: 1000, max: 10000 } },
      { label: "Micro (10k - 50k)", value: { min: 10000, max: 50000 } },
      { label: "Mid-Tier (50k - 100k)", value: { min: 50000, max: 100000 } },
      { label: "Macro (100k - 500k)", value: { min: 100000, max: 500000 } },
      { label: "Mega (500k - 1M)", value: { min: 500000, max: 1000000 } },
      { label: "Celebrity (1M+)", value: { min: 1000000 } },
    ],
  },

  {
    facetName: "creator_locations",
    hideFilter: true,
    title: "Location",
    compType: "multiList",
    desc: "Filter creators who is from the selected location. ",
    placeHolder: "Search country or city",
    fType: "creator",
  },

  {
    facetName: "topics",
    title: "Topics",
    hideFilter: true,
    compType: "multiList",
    desc: "Filter creators by topics",
    placeHolder: "Search by topics",
    fType: "creator",
  },
  {
    facetName: "creator_gender",
    title: "Creator's Gender",
    compType: "list",
    desc: "Filter creators by gender of the creator.",
    placeHolder: "",
    fType: "creator",
  },
  {
    facetName: "creator_age",
    title: "Creator's Age",
    compType: "range",
    desc: "Filter creators by creator's age.",
    placeHolder: "Select range",
    fType: "creator",
    optionsList: [
      { label: "13-17", value: { min: 13, max: 17 } },
      { label: "18-24", value: { min: 18, max: 24 } },
      { label: "25-34", value: { min: 25, max: 34 } },
      { label: "35-44", value: { min: 35, max: 44 } },
      { label: "45-54", value: { min: 45, max: 54 } },
      { label: "55-64", value: { min: 55, max: 64 } },
    ],
  },
  {
    facetName: "creator_language",
    title: "Creator's language",
    compType: "list",
    desc: "Filter creators by creators language.",
    placeHolder: "Search Language",
    fType: "creator",
  },
  {
    facetName: "is_verified",
    title: "Is verified?",
    compType: "checkbox",
    desc: "Filter creators by platform verification status.",
    placeHolder: "",
    fType: "creator",
  },
  {
    facetName: "bio_phrase",
    title: "Bio phrase",
    compType: "tags",
    desc: "Filter creators by the phrase they use in their bio.",
    fType: "creator",
    placeHolder: "Search keywords in the bio of Creators",
  },
  {
    facetName: "description_keywords",
    title: "Keywords",
    compType: "tags",
    desc: "Filter creators by keywords that can be found in creator's posts caption.",
    fType: "content",
    placeHolder: "Search by keywords",
  },

  {
    facetName: "average_views",
    title: "Average Views",
    compType: "range",
    desc: "Filter creators by  average  views.",
    placeHolder: "",
    fType: "performance",
    optionsList: [
      { label: "0 - 1k", value: { min: 0, max: 1000 } },
      { label: "1k - 10k", value: { min: 1000, max: 10000 } },
      { label: "10k - 50k", value: { min: 10000, max: 50000 } },
      { label: "50k - 100k", value: { min: 50000, max: 100000 } },
      { label: "100k - 500k", value: { min: 100000, max: 500000 } },
      { label: "500k - 1M", value: { min: 500000, max: 1000000 } },
      { label: "1M+", value: { min: 1000000 } },
    ],
  },
  {
    facetName: "engagement_rate",
    title: "Engagement Rate",
    compType: "inputNumber",
    desc: "Filter creators by engagement rates.",
    placeHolder: "Select engagement rate",
    fType: "performance",
    optionsList: [
      { label: ">2%", value: 2 },
      { label: ">4%", value: 4 },
      { label: ">6%", value: 6 },
      { label: ">8%", value: 8 },
      { label: ">10%", value: 10 },
    ],
  },
  {
    facetName: "audience_locations",
    title: "Top Audience Location",
    compType: "selectRange",
    desc: "Filter creators who's audience is from the selected location.",
    placeHolder: "Search country or city",
    fType: "audience",
  },

  {
    facetName: "audience_age",
    title: "Audience Age",
    compType: "selectRange",
    desc: "Filter creators by audience age.",
    placeHolder: "Search country or city",
    fType: "audience",
    optionsList: [
      { label: "13-17", value: { min: 13, max: 17 } },
      { label: "18-24", value: { min: 18, max: 24 } },
      { label: "25-34", value: { min: 25, max: 34 } },
      { label: "35-44", value: { min: 35, max: 44 } },
      { label: "45-54", value: { min: 45, max: 54 } },
      { label: "55-64", value: { min: 55, max: 64 } },
    ],
  },
  {
    facetName: "audience_gender",
    title: "Audience Gender",
    compType: "selectRange",
    desc: "Filter creators by gender of the audience.",
    placeHolder: "Search Gender",
    fType: "audience",
  },
];

export const GLOBAL_DISCOVERY_NOTIFICATIONS_QUERY_KEY = [
  "discovery-notifications",
];
